import { render, staticRenderFns } from "./PergolaSpecifications.vue?vue&type=template&id=02d596d4&scoped=true"
import script from "./PergolaSpecifications.vue?vue&type=script&lang=ts"
export * from "./PergolaSpecifications.vue?vue&type=script&lang=ts"
import style0 from "./PergolaSpecifications.vue?vue&type=style&index=0&id=02d596d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d596d4",
  null
  
)

export default component.exports